module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Sub_Amp.9b45bd1a.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Sub_Amp.svg
// module id = 3543
// module chunks = 0